import React, { useContext, useEffect, useState } from "react";
import "./style.scss";
import { Pagination, Table } from "antd";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  useGetAllBatchesForSeggreagtion,
  useGetAllClientForSegg,
} from "../../../hooks/useSeggregation";
import { SeggreagtionContext } from "../../../context/seggregationProvider";
const SeggregationBatchList = () => {
  const [batchList, setBatchList] = useState([]);
  const [batchPageSize, setBatchPageSize] = useState(15);
  const [batchPageNum, setBatchPageNum] = useState(1);
  const [batchTotalCount, setBatchTotalCount] = useState(0);

  const [clientPageSize, setClientPageSize] = useState(15);
  const [clientPageNum, setClientPageNum] = useState(1);
  const [clientTotalCount, setClientTotalCount] = useState(0);
  const [activeProfile, setActiveProfile] = useState("");
  const [clientList, setClientList] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const isActive = (profile) => (activeProfile === profile ? "activeBtn" : "");
  const { segg_setSelectedCategory, segg_setSelectedSubCategory } =
    useContext(SeggreagtionContext);
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const activeProf = queryParams.get("activeProfile");
    setActiveProfile(activeProf || "batch");
  }, [location.search]);

  useEffect(() => {
    if (activeProfile === "client") {
      getAllClient({ pageNum: clientPageNum, pageSize: clientPageSize });
    } else if (activeProfile === "batch") {
      getAllBatches({ pageNum: batchPageNum, pageSize: batchPageSize });
    }
  }, [
    activeProfile,
    clientPageNum,
    clientPageSize,
    batchPageNum,
    batchPageSize,
  ]);
  const onBatchPageChange = (page, size) => {
    if (page !== batchPageNum) {
      setBatchPageNum(page);
    } else {
      setBatchPageSize(size);
      setBatchPageNum(1);
    }
  };
  const onClientPageChange = (page, size) => {
    if (page !== clientPageNum) {
      setClientPageNum(page);
    } else {
      setClientPageSize(size);
      setClientPageNum(1);
    }
  };
  const batchColumns = [
    {
      title: "Batch No.",
      key: "batchNumber",
      align: "left",
      dataIndex: "batchNumber",
      render: (_, record, index) => {
        return (
          <div className="">
            {record?.batchNumber ? record?.batchNumber : "N/A"}
          </div>
        );
      },
    },
    {
      title: "Batch Name",
      key: "name",
      align: "center",
      dataIndex: "name",
      render: (_, record, index) => {
        return (
          <div>
            {`${record?.name} ${
              record?.lastName != null ? record?.lastName : ""
            }` || ""}
          </div>
        );
      },
    },
    {
      title: "Source",
      key: "sourceName",
      align: "center",
      dataIndex: "name",
      render: (_, record, index) => {
        return <div>{record?.source?.name}</div>;
      },
    },
    {
      title: "Email",
      key: "email",
      align: "center",
      dataIndex: "email",
      render: (_, record, index) => {
        return <div>{record?.user?.email?.emailId}</div>;
      },
    },
    {
      title: "Order Created",
      key: "deliveredSkus",
      align: "center",
      dataIndex: "deliveredSkus",
      render: (_, record, index) => {
        return (
          <div>
            {record?.batchCreationAt
              ? new Date(record?.batchCreationAt).toISOString().split("T")[0]
              : "-"}
          </div>
        );
      },
    },
    {
      title: "No. of Images",
      key: "NoOfImages",
      align: "center",
      dataIndex: "NoOfImages",
      render: (_, record, index) => {
        return <div>{record?.numberOfInputImages || "-"}</div>;
      },
    },
    {
      title: "Pending Skus",
      key: "pendingSkus",
      align: "center",
      dataIndex: "totalPendingSkuOnSegregation",
      render: (_, record, index) => {
        return <div>{record?.totalPendingSkuOnSegregation || "-"}</div>;
      },
    },
    // {
    //   title: "Status",
    //   key: "status",
    //   align: "center",
    //   dataIndex: "status",
    //   render: (_, record) => {
    //     return <div>{record?.displayStage}</div>;
    //   },
    // },
    {
      title: "Action",
      key: "action",
      align: "center",
      dataIndex: "action",
      render: (_, record) => {
        return (
          <div>
            <Link
              to={`/seggregation-batch-loading?batchId=${record?._id}`}
              onClick={() => {
                segg_setSelectedCategory("");
                segg_setSelectedSubCategory("");
              }}
            >
              Start
            </Link>
          </div>
        );
      },
    },
  ];
  const clientColumns = [
    {
      title: "S.No.",
      key: "s.no.",
      align: "center",
      dataIndex: "index",
      render: (_, record, index) => {
        return <div>{index + 1}</div>;
      },
    },
    {
      title: "Name",
      key: "clientName",
      align: "center",
      dataIndex: "clientName",
      render: (_, record, index) => {
        return (
          <div>
            {record?.users[0]?.name} {record?.users[0]?.lastName}
          </div>
        );
      },
    },
    {
      title: "Email",
      key: "clientEmail",
      align: "center",
      dataIndex: "clientEmail",
      render: (_, record) => {
        return <div>{record?.users[0]?.email?.emailId}</div>;
      },
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      dataIndex: "action",
      render: (_, record) => {
        return (
          <div>
            <Link to={`/seggregation-batch-loading?orgId=${record?._id}`}>
              Start
            </Link>
          </div>
        );
      },
    },
  ];
  const onSuccessGetAllBatches = (res) => {
    if (res.status === 200) {
      setBatchList(res.data.data);
      setBatchTotalCount(res?.data?.totalCount);
    }
  };
  const onErrorGetAllBatches = (err) => {
    console.log(err);
  };
  const { mutate: getAllBatches } = useGetAllBatchesForSeggreagtion(
    onSuccessGetAllBatches,
    onErrorGetAllBatches
  );
  const onSuccessGetAllClients = (res) => {
    if (res.status === 200) {
      setClientList(res?.data?.data);
      setClientTotalCount(res?.data?.totalCount);
    }
  };
  const onErrorGetAllClients = (err) => {
    console.log(err);
  };
  const { mutate: getAllClient } = useGetAllClientForSegg(
    onSuccessGetAllClients,
    onErrorGetAllClients
  );
  const updateURLParams = (profile) => {
    const queryParams = new URLSearchParams(location.search);
    queryParams.set("activeProfile", profile);
    navigate({
      pathname: location.pathname,
      search: queryParams.toString(),
    });
  };
  return (
    <div className="seggregation_batch_list">
      <div className="seggregation_batch_list_content">
        {/* <div className="tab_wrapper">
          <button
            className={`batchBtn ${isActive("batch")}`}
            onClick={() => {
              setActiveProfile("batch");
              updateURLParams("batch");
            }}
          >
            Batch
          </button>
          <button
            className={`clientBtn ${isActive("client")}`}
            onClick={() => {
              setActiveProfile("client");
              updateURLParams("client");
            }}
          >
            Client
          </button>
        </div> */}
        {activeProfile === "batch" ? (
          <>
            <div className="list_wrapper">
              <Table
                columns={batchColumns}
                dataSource={batchList}
                scroll={{
                  // x: 2100,
                  y: `100%`,
                }}
                className="main_table"
                pagination={false}
                rowClassName={(record) =>
                  !record?.user?.isInternalUser ? "red-row" : ""
                }
              />
            </div>
            <div className="pagination_wrapper">
              <Pagination
                total={batchTotalCount}
                current={batchPageNum}
                pageSize={batchPageSize}
                onChange={onBatchPageChange}
                showSizeChanger={false}
              />
            </div>
          </>
        ) : (
          <>
            <div className="list_wrapper">
              <Table
                columns={clientColumns}
                dataSource={clientList}
                scroll={{
                  // x: 2100,
                  y: `calc(100%)`,
                }}
                className="main_table"
                pagination={false}
                rowClassName={(record) =>
                  !record?.user?.isInternalUser ? "red-row" : ""
                }
              />
            </div>
            <div className="pagination_wrapper">
              <Pagination
                total={clientTotalCount}
                // showTotal={false}
                defaultPageSize={10}
                current={clientPageNum}
                pageSize={clientPageSize}
                onChange={onClientPageChange}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default SeggregationBatchList;
